import { jwtDecode } from "jwt-decode";
import { getCookieValue } from "./cookies";

/**
 * Retrieves UUID and token from the session.
 * @returns {Object} An object containing UUID and token extracted from the session.
 * @returns {string|null} An object property `uuid` containing the UUID, or `null` if not found.
 * @returns {string|null} An object property `token` containing the token, or `null` if not found.
 */
const getSubFromSession = () => {
  const token = getCookieValue("wwSession");

  if (!token)
    return {
      uuid: null,
      token: null
    };

  const decoded = jwtDecode(token);
  const { sub } = decoded || {};

  return {
    uuid: sub,
    token
  };
};

export default getSubFromSession;
